import type { QueryClient } from "@tanstack/react-query";
import type { ComponentProps } from "react";
import { useCallback } from "react";
import { usePreload } from "./use-preload.ts";

type Loader<T> = (params: T, queryCLient: QueryClient) => Promise<void>;

export function useLinkPreload<T>(
  loader: Loader<T>,
  params: T,
): Pick<ComponentProps<"a">, "onMouseEnter" | "onFocus"> {
  const preload = usePreload(loader);

  const handler = useCallback(() => preload(params), [params, preload]);

  return {
    onMouseEnter: handler,
    onFocus: handler,
  };
}
